import React from 'react';
import { func } from 'prop-types';
import DEBreadcrumb from '../../shared/DEBreadcrumb';

const TargetMainHeader = ({ setView }) => {
  return (
    <div className="de--header" data-test="target-main-header">
      <div className="de--header-title">
        <h2>
          <button
            className="de-header-title--link"
            onClick={() => setView('Dashboard')}
            type="button"
          >
            Available Targets
          </button>{' '}
          / <span>Reports</span>
        </h2>
      </div>
      <DEBreadcrumb parent="DataHub / " child="Activate Campaign Targets" />
    </div>
  );
};

TargetMainHeader.propTypes = {
  setView: func,
};

export default TargetMainHeader;
